import { Outlet } from 'react-router-dom'
import { LanguageSwitcher } from '@/components/common/LanguageSwitcher'

export default function LoginLayout() {
  return (
    <div
      className='min-h-screen w-full bg-cover bg-center bg-no-repeat flex items-center justify-center'
      style={{
        backgroundImage: 'url(/login-background.jpeg)',
      }}
    >
      <div className='absolute inset-0 bg-black/5' />

      <div className='absolute top-4 right-4 z-20'>
        <LanguageSwitcher />
      </div>

      <div className='relative z-10 w-full'>
        <Outlet />
      </div>
    </div>
  )
}
